import { Application } from './applications';

export type InterviewDetailsStatus =
  | 'INTERVIEW_REQUEST_SENT'
  | 'SLOT_PROVIDED'
  | 'SCHEDULED'
  | 'WITHDRAWN'
  | 'DECLINED';

export enum SlotType {
  Proposed = 'proposed',
  Selected = 'selected'
}

export interface InterviewSlot {
  id: number;
  start: Date;
  end: Date;
}

export interface InterviewSlotSerialized {
  id: number;
  start: string;
  end: string;
}

export interface CalendarEvent extends InterviewSlot {
  type: SlotType;
}

export interface CalendarEventSerialized extends InterviewSlotSerialized {
  type: SlotType;
}

export interface InterviewSlotsState {
  slots: InterviewSlotSerialized[];
  proposedSlots: InterviewSlotSerialized[];
  selectedSlot: InterviewSlotSerialized | null;
  applicationId: string | null;
  isLoading: boolean;
  error: string | null;
}

export interface InterviewSlotsRequest {
  slotList: InterviewSlotSerialized[];
  timeZone: string;
}

export interface InterviewSlots {
  hostLink?: string;
  joinLink?: string;
  slotList: InterviewSlotSerialized[];
  timeZone: string;
}

export interface InterviewDetails {
  application: Application;
  status: InterviewDetailsStatus;
  body: null;
  createdDate: string;
  editDate: string;
  slots: InterviewSlots;
  id: string;
}

export interface InterviewConfirm {
  setupMeeting: boolean;
  slot: InterviewSlots;
  meetingLink?: string;
  clientNotes?: string;
}
